export default __webpack_public_path__ + "static/media/show_password_icon_old.e97f7200.svg";